import React from 'react'
import { Icon } from '@mobi/component-library/Assets/Icon'
import {
  PasswordCriteriaListStyled,
  PasswordCriteriaListDetailsStyled,
} from './PasswordCriteriaList.styled'
import { spacing } from '@mobi/component-library/Foundations'
import { PasswordCriteria } from './PasswordValidate'

type PasswordCriteriaDisplayProps = {
  unmetCriteria: PasswordCriteria[]
}

export const PasswordCriteriaList = ({ unmetCriteria }: PasswordCriteriaDisplayProps) => {
  const noUpperAndLowerLetters = unmetCriteria.includes(
    PasswordCriteria.containsUpperAndLowerLetters
  )
  const noNumberOrSpecialCharacter = unmetCriteria.includes(
    PasswordCriteria.containsNumberOrSpecialCharacter
  )
  const notEnoughCharacters = unmetCriteria.includes(PasswordCriteria.sufficientLength)

  return (
    <PasswordCriteriaListStyled>
      <PasswordCriteriaListDetailsStyled isValid={!noUpperAndLowerLetters}>
        {!noUpperAndLowerLetters ? <ValidIcon /> : <InvalidIcon />} Uppercase and lowercase letters
      </PasswordCriteriaListDetailsStyled>
      <PasswordCriteriaListDetailsStyled isValid={!noNumberOrSpecialCharacter}>
        {!noNumberOrSpecialCharacter ? <ValidIcon /> : <InvalidIcon />} At least one number or
        special character
      </PasswordCriteriaListDetailsStyled>
      <PasswordCriteriaListDetailsStyled isValid={!notEnoughCharacters}>
        {!notEnoughCharacters ? <ValidIcon /> : <InvalidIcon />} 8 or more characters
      </PasswordCriteriaListDetailsStyled>
    </PasswordCriteriaListStyled>
  )
}

const ValidIcon = () => <Icon name='DuocolorCheckCircle' size={spacing.md} />
const InvalidIcon = () => <Icon name='DuocolorXCircle' size={spacing.md} />
